import React, { forwardRef, useImperativeHandle, useState, Fragment } from 'react';
import { InfoWindow } from "@react-google-maps/api";
import axios from 'axios';

import SvgIcon from "../../SharedComponents/Icons";
import Place from "../PlacesList/Place";
import PlaceholderImg from '../../../src/images/listviewpage/placeholder.jpeg';


const InfoWrapper = forwardRef((props, ref) => {

  const [markerInfo, setMarkerInfo] = useState();
  const [markersInfo, setMarkersInfo] = useState();
  const [windowPosition, setWindowPosition] = useState();

  const { setActivePlaceId, setRequestError } = props;

  const show = (id, pos, ids) => {
    const sameMarker = markerInfo && id === markerInfo.id;
    const idsList = ids || [id];
    let locationsParamsIds = '';

    idsList.map(id => locationsParamsIds = locationsParamsIds + `ids[]=${id}&`);
    setWindowPosition(pos);
    setMarkerInfo(null);
    setMarkersInfo(null);
    setActivePlaceId(null);

    !sameMarker &&
      axios.get(`/api/frontend/places/markers_info.json?${locationsParamsIds}`)
        .then((response) => {
          const { data } = response;

          ids ? setMarkersInfo(data.map(marker => JSON.parse(marker).data.attributes)) : setMarkerInfo(JSON.parse(data[0]).data.attributes);
          setActivePlaceId(id);
        })
        .catch(error => {
          console.log('Error: ', error);
          setRequestError(true);
        });
  };


  const close = () => {
    setMarkerInfo(null);
    setMarkersInfo(null);
  };


  const onInfoToggle = () => {
    setMarkerInfo(null);
    setMarkersInfo(null);
    setActivePlaceId(null);
  };


  useImperativeHandle(ref, () => ({
    show, close,
  }), [show, close]);


  const placesList = () => markersInfo &&
    <div className="markers-list">
      <div className="markers-list__close-btn" onClick={() => onInfoToggle()}>
        <SvgIcon name="close" size={24} />
      </div>

      <div className="markers-list__top-wrapper">
        <div className="markers-list__address">
          { markersInfo[0].address_line_1 }
        </div>

        <div className="markers-list__header">
          Lokaler på denne adresse:
        </div>
      </div>

      <div className="markers-list__locations-list">
        { markersInfo.map((marker, index) =>
          <Fragment>
            <a href={marker.url} className="markers-list__card" target="_blank">
              <div className="markers-list__card-img" style={{ backgroundImage: `url(${marker.medium_photo_url || PlaceholderImg})` }} />
              <div className="markers-list__card-info-wrapper">
                <div className="markers-list__card-kind">
                  { marker.category.name }
                </div>

                { (marker.price_per_seat || marker.guest_capacity) &&
                  <div className="markers-list__card-info">
                    <div className="markers-list__card-info-label">
                      <SvgIcon name={ marker.price_per_seat ? 'price' : 'users2' } size={18} />
                      { marker.price_per_seat ? 'Pris' : 'Gæster' }:
                    </div>
                    <div className="markers-list__card-info-value">
                      { marker.price_per_seat || marker.guest_capacity }
                    </div>
                  </div>
                }

                <div className="markers-list__card-read-more">
                  Læs mere
                  <SvgIcon name="keyboard-arrow-right-rounded-ios" size={14} />
                </div>
              </div>
            </a>
            { index !== markersInfo.length - 1 &&
              <div className="markers-list__devider" />
            }
          </Fragment>
        )}
      </div>
    </div>;


  if (markerInfo || markersInfo) {
    return (
      <InfoWindow position={windowPosition} onUnmount={() => onInfoToggle(props.activePlaceId)}>
        <div className="marker-info-window">
          { markerInfo
            ?
              <Fragment>
                <div className="info-window-close-btn" onClick={() => onInfoToggle()}>
                  <SvgIcon name="close" size={24} />
                </div>
                <Place place={markerInfo} descriptionWidth={315} />
              </Fragment>
            : placesList()
          }
        </div>
      </InfoWindow>
    )
  } else {
    return null;
  }
})

export default InfoWrapper;
